export default "__VITE_ASSET__BCK1W7m9__"